import { faXmark } from '@fortawesome/free-solid-svg-icons'
import Hero from '../../assets/images/hero.png'
import Icon from '../Icon'
import PlusMinusButton from '../elements/PlusMinusButton'


export default () => {
    return (
        <div className="card rounded-4 p-3 m-3 position-relative cart-product">
            <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12 rounded-4 mb-3" style={{ maxWidth: "180px", height: "200px" }}>
                    <img src={Hero} className="border border-1 rounded-4" style={{ maxWidth: "180px", height: "200px" }} />
                </div>
                <div className='col-lg-8 col-md-6 col-sm-12'>
                    <div className='ms-3'>
                        <h4 className="custom-text-color ">Lord Ganesh Brass Statue</h4>
                        <Icon icon={faXmark} className="position-absolute cursor-pointer" style={{ top: "10px", right: "10px" }} />
                        <p className="fs-9 mb-4 w-75">Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur suscipit nisi deserunt cupiditate illum itaque fugiat quam qui animi debitis.</p>
                        <p className="fs-5 x-bold text-saffron"><span className="text-decoration-line-through text-muted me-3">₹400</span> ₹350</p>
                        <div className="d-flex align-items-center flex-wrap">
                            <div className='m-2 d-flex'>
                                <p className="me-3 mb-0 bold custom-text-color">Quantity: </p>
                                <PlusMinusButton />
                            </div>
                            <div className='m-2 d-flex'>
                                <p className="me-3 mb-0 bold custom-text-color">Choose Size: </p>
                                <select>
                                    <option>Small</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}